module.exports = __webpack_public_path__ + "assets/img/00152.5749c6e8.png";